export class EventArg {
    constructor(
        public eventName: string = '',
        public eventValue: string  = '',
        public eventObject: any = null
    ) { }
}
